<template>
    <div class="lightbox-gallery">
        <fs-lightbox :toggler="toggler" :sources="images" type="image" :sourceIndex="index"></fs-lightbox>
        <a href="#" v-for="(i, idx) in images" @click.stop.prevent="toggler = ! toggler; index = idx">
            <img :src="i" class="lightbox-gallery--image" alt="Galerie">
        </a>
    </div>

</template>

<script>
  export default{
    props:{
      images : {
        type : Array,
        required : true
      },
    },
    data() {
      return {
        toggler: false,
        index: 0,
      }
    }
  }
</script>

<style>
    .lightbox-gallery--image {
        max-height: 200px;
        max-width: 200px;
    }
</style>
